import { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { boyApi } from "@/lib/boy";
import { RideRequest } from "./RideRequest";
import { RideList } from "./RideList";
import { StoreLocation } from "./StoreLocation";

export function MerchantHome({ code, onLogout }) {
  const bx = useMemo(() => boyApi(code), [code]);
  const [me, setMe] = useState(null);
  const [params, setParams] = useSearchParams();
  const load = useCallback(async () => {
    try {
      const { data } = await bx.get("/me");
      setMe(data);
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(errMsg(e));
        onLogout();
      }
    }
  }, [bx, onLogout]);
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);
  useEffect(() => {
    const rid = params.get("corrida");
    if (!rid) return;
    setParams({}, { replace: true });
    bx.get(`/rides/${rid}`).then(({ data }) => {
      if (data.payment.status === "pago") toast.success(`Pagamento confirmado! Estamos chamando os motoboys para a corrida #${data.number}.`);
      else toast.message(`Corrida #${data.number}: o pagamento ainda não foi confirmado.`);
      load();
    }).catch(() => {});
  }, [params, setParams, bx, load]);
  if (!me) return <p className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin" /></p>;
  return (
    <div className="space-y-6" data-testid="boy-merchant-home">
      <div className="card-surface flex items-center justify-between gap-3 p-4">
        <div className="min-w-0"><p className="text-xs text-muted-foreground">Olá,</p><p className="truncate font-semibold" data-testid="boy-merchant-name">{me.merchant.name}</p></div>
        <Button variant="ghost" size="sm" onClick={onLogout} data-testid="boy-logout-btn"><LogOut className="mr-2 h-4 w-4" />Sair</Button>
      </div>
      <StoreLocation code={code} bx={bx} merchant={me.merchant} onSaved={load} />
      <RideRequest bx={bx} merchant={me.merchant} canPay={me.can_pay} />
      <RideList bx={bx} rides={me.rides} onChange={load} />
    </div>
  );
}
